import * as React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import RoastForm from '../components/RoastForm';
import ExampleSection from '../components/ExampleSection';
import TestimonialSection from '../components/TestimonialSection';
import FAQSection from '../components/FAQSection';
import PromoBanner from '../components/PromoBanner';

// Array of funny taglines for the title
const funnyTaglines = [
  "Where 5-star reviews come to die",
  "Making product managers cry since 2023",
  "Brutally honest, hilariously savage",
  "Your listing's worst nightmare",
  "When honesty meets hilarity",
  "Trust us, we've seen worse... maybe",
  "Selling dreams, roasting reality",
  "Because your marketing team needs a reality check",
  "Turning good listings great, bad listings infamous",
  "Where AI has no chill",
  "Better than your ex's product review",
  "We don't sugarcoat, we flame-broil",
  "The roast you didn't ask for, but definitely need",
  "Proving computers can be funnier than humans",
  "Your products' intervention moment",
  "Taking 'constructive criticism' to a new level",
  "The AI that pulls no punches",
  "Making Karens look nice since 2023",
  "The truth hurts, but it sells better",
  "Like a product review, but with attitude"
];

const Landing: React.FC = () => {
  // Select a random tagline when the component mounts
  const [tagline, setTagline] = React.useState<string>("");
  
  React.useEffect(() => {
    // Pick a random tagline
    const randomTagline = funnyTaglines[Math.floor(Math.random() * funnyTaglines.length)];
    setTagline(randomTagline);
    
    // Set up visibility change handler to update tagline when tab becomes visible
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const newTagline = funnyTaglines[Math.floor(Math.random() * funnyTaglines.length)];
        setTagline(newTagline);
      }
    };
    
    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  
  return (
    <HelmetProvider>
      <div>
        <Helmet>
          <title>RoastMyListing.ai - {tagline || "Free Analysis & Optimization"}</title>
          <meta name="description" content="Get a free, instant analysis of your Amazon listing with actionable tips to increase rankings and conversion" />
        </Helmet>
        
        {/* Promotional Banner */}
        <PromoBanner />
        
        {/* Main content with RoastForm */}
        <RoastForm />
        
        {/* Examples */}
        <ExampleSection />
        
        {/* Testimonials */}
        <TestimonialSection />
        
        {/* FAQ */}
        <FAQSection />
      </div>
    </HelmetProvider>
  );
};

export default Landing;
